"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_Column = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_Column = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: column;\n    padding: var(--spacing-none);\n    margin: var(--spacing-none);\n    justify-content: ", ";\n    align-items: ", ";\n    height: ", ";\n"])), function (props) {
  if (props.spacing === 'start') {
    return 'flex-start';
  } else if (props.spacing === 'end') {
    return 'flex-end';
  } else if (props.spacing === 'center') {
    return 'center';
  } else if (props.spacing === 'between') {
    return 'space-between';
  } else if (props.spacing === 'around') {
    return 'space-around';
  } else if (props.spacing === 'evenly') {
    return 'space-evenly';
  }
}, function (props) {
  if (props.alignment === 'start') {
    return 'flex-start';
  } else if (props.alignment === 'end') {
    return 'flex-end';
  } else if (props.alignment === 'center') {
    return 'center';
  }
}, function (props) {
  return props.height;
});
exports.Occ_Column = Occ_Column;